import contigoImage from '../../assets/images/CONTIGO.png';
import JuegoCarrera from '../Home/CarreraUniversitaria/JuegoCarrera'; 
import ProtectedRoute from '../Auth/ProtectedRoute';
import { useAuth } from '../Auth/AuthContext'; 
import './Home.css';

const Home = () => {
    const { isAuthenticated, isStudent, loading } = useAuth();

    // Si está cargando, mostrar un loader o no mostrar nada
    if (loading) {
        return (
            <div>
                {/* Sección de Carrera Universitaria */}
                <section className="info-section">
                    <img src={contigoImage} alt="Imagen de fondo" className="info-image" />
                </section>
                {/* Puedes agregar un loader aquí si quieres */}
            </div>
        );
    }

    return (
        <div className="home-container">
            {/* Sección de Carrera Universitaria */}
            <section className="info-section">
                <img src={contigoImage} alt="Imagen de fondo" className="info-image" />
            </section>

            {/* Rectángulo separador - Solo si está autenticado y es estudiante */}
            {isAuthenticated && isStudent() && (
                <div className="separator-rectangle"></div>
            )}

            {/* Componente JuegoCarrera - Solo si está autenticado y es estudiante */}
            {isAuthenticated && isStudent() && (
                <ProtectedRoute requireAuth={true} requiredUserType={1}>
                    <JuegoCarrera />
                </ProtectedRoute>
            )}
        </div>
    );
};

export default Home;